/**
 * Opciones de estado para items de cotización
 * @returns {Array} Array de opciones de estado
 */
export const getStatusOptions = () => [
    { id: 1, name: 'Activo' },
    { id: 0, name: 'Inactivo' }
];

/**
 * Opciones de moneda
 * @returns {Array} Array de opciones de moneda
 */
export const getCurrencyOptions = () => [
    { id: 'USD', name: 'USD' },
    { id: 'COP', name: 'COP' }
];

/**
 * Opciones de tipo de unidad
 * @returns {Array} Array de opciones de tipo de unidad
 */
export const getUnitTypeOptions = () => [
    { id: 'UND', name: 'UND' },
    { id: 'DÍAS', name: 'DÍAS' }
];

/**
 * Opciones de estado para cotizaciones
 * @returns {Array} Array de opciones de estado de cotización
 */
export const getQuotationStatusOptions = () => [
    { id: 'draft', name: 'Borrador' },
    { id: 'sent', name: 'Enviada' },
    { id: 'approved', name: 'Aprobada' },
    { id: 'rejected', name: 'Rechazada' },
    { id: 'canceled', name: 'Cancelada' }
];

